import React, { useState, useEffect } from "react";
import CustomTable from "../../../customComponents/CustomTable";
import downloadIcon from "../../../../Assets/icons/download.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import mailIcon from "../../../../Assets/icons/mailIcon.svg";
import download from "../../../../Assets/icons/download.svg";
import claimIcon from "../../../../Assets/icons/ClaimIcon.svg";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import ListFilters from "../OnBoardManagement/ListFilters";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import searchIcon from "../../../../Assets/icons/searchicon.svg";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../customComponents/CustomLoader";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import DetailsTable from "./CustomOrderTable/CustomOrderTable";
// import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { showAlert } from "../../../customComponents/CustomSweetAlert/ShowAlert";
import * as base64 from "base-64";
import Swal from "sweetalert2";
import { showErrorAlert } from "../../../customComponents/CustomSweetAlert/errorsweetalert";

const OrderManagementListService = () => {
  const [actionTaken, setActionTaken] = useState([]);
  const [actionTakenAdmin, setActionTakenAdmin] = useState([]);
  const navigate = useNavigate();
  const [dealerOption, setDealerOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [rejectedOrders, setRejectedOrders] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);

  const [selectedPoId, setSelectedPoId] = useState(null);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [showSerialModal, setShowSerialModal] = useState(false);

  const handleModalOpen = () => {
    setShowSerialModal(true);
  };

  const handleModalClose = () => {
    setShowSerialModal(false);
  };

  // Removed localStorage logic for filters

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const TABLE_HEADERS = [
    "PO No.",
    "PO Date",
    "Dealer PO Expected Date",
    "PO Revised Date",
    "Role",
    "Created By",
    "Dealer Name",
    "Total-Price",
    // "Paid Amount",
    // "Pending Amount",
    "Status",
    "Remark",
    "Action",
  ];

  const keyMapping = {
    "PO No.": "po_number",
    "PO Date": "po_date",
    "PO Type": "po_type",
    "Created By": "created_by_name",
    Role: "role_name",
    "Dealer PO Expected Date": "po_dealer_expected_date",
    "PO Revised Date": "po_delivery_date",
    "Dealer Name": "dealer_name",
    "Ref. No.": "ref_no",
    Department: "department",
    Quantity: "quantity",
    "Payment term": "payment_term_name",
    "Payment Mode": "payment_mode",
    Status: "status",
    Remark: "approval_remark",
    "Total-Price": "total",
    "Paid Amount": "paidAmount",
    "Pending Amount": "penddingAmount",
    Action: [
      { type: "mailOrder", icon: mailIcon, label: "Mail" },
      { type: "view", icon: eyeIcon, label: "View" },
      {
        type: "acceptorderdetails",
        icon: download,
        label: "Print",
      },
      {
        type: "OrderClaimIcon",
        icon: claimIcon,
        label: "claimIcon",
      },
    ],
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchActionTaken(newPage);
  };
  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchActionTaken();
  // };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchActionTaken();
  };

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const fetchActionTaken = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    try {
      const formattedStartDate = formatDateToYYYYMMDD(
        allfilteredData?.fromDate,
      );
      const formattedEndDate = formatDateToYYYYMMDD(allfilteredData?.toDate);
      setLoading(true);
      const response = await axiosInstance.post(
        "/purchaseorder/acceptlist",
        {
          orderBy: "po_id desc",
          page,
          pageSize,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          dealerId: allfilteredData.dealerId || null,
          // is_order_accepted: allfilteredData?.is_order_accepted
          //   ? allfilteredData?.is_order_accepted
          //   : "",
          // is_order_accepted:
          //   allfilteredData?.is_order_accepted === 0 ||
          //   allfilteredData?.is_order_accepted === "0"
          //     ? -1
          //     : allfilteredData?.is_order_accepted ?? 0,
          is_order_accepted: allfilteredData.is_order_accepted,
          searchText: searchTerm,
          poItemType:"I",

        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        po_type: item.po_type || "- -",
        po_expected_date: item.po_expected_date || "--",
        po_delivery_date: item.po_delivery_date || "--",
        total: item.total || "--",
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.countdata?.total_pending;
      const totalInac = response?.data?.data?.countdata.total_active;
      const rejectedOrders = response?.data?.data?.countdata.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);
      setRejectedOrders(rejectedOrders);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setActionTaken(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleSearch = () => {
  //   // Update the filters state with the current form data
  //   setFilters({
  //     is_order_accepted: filterFormData.is_order_accepted || 0,
  //     fromDate: filterFormData.startDate || null,
  //     toDate: filterFormData.endDate || null,
  //     city: filterFormData.city_id || null,
  //   });
  // };

  const handleSearch = () => {
    const updatedFilters = {
      // is_order_accepted: filterFormData.is_order_accepted || 0,
      is_order_accepted:
        filterFormData.is_order_accepted !== undefined &&
        filterFormData.is_order_accepted !== null
          ? filterFormData.is_order_accepted
          : -1, // default All
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
      dealerId: filterFormData.dealerId || null,
    };

    setFilters(updatedFilters);
  };

  useEffect(() => {
    fetchActionTaken(0, 10);
  }, [filters]);

  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.ACCEPTORDERDETAILS}`, {
      state: { data: rowData },
    });
    // console.log("rowdata", rowData)
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchActionTaken();
    }
  }, [searchTerm]);
  useEffect(() => {
    setFilterFormData({ ...filterFormData, searchtype: 1 });
  }, []);
  // useEffect(()=>{
  //   setFilters();
  //   fetchActionTaken();
  // },[filterFormData])

  // useEffect(() => {
  //   setFilterFormData({
  //     is_order_accepted: "",
  //   });
  // }, []);

  // Partially Rejected by Dealer
  // Rejected by Dealer
  // Received with Damaged Items Accepted
  // Received with Damaged Items Rejected

  const PhysicalStockTakingInputs = [
    {
      name: "is_order_accepted",
      label: "SearchType",
      placeholder: "Select City",
      type: "dropdown",
      options: [
        { label: "All", value: -1 },
        { label: "Order Pending", value: 0 },
        { label: "Modified", value: 8 },
        { label: "Order Approved", value: 1 },
 
        { label: "Order Partially Delivered", value: 5 },
        // { label: "Order Hold", value: 4 },
        { label: "Dispatched", value: 3 },
        { label: "Order Rejected", value: 2 },
        // { label: "Order Cancelled", value: 7 },
        // { label: "Modified Status", value: 8 },
        { label: "Re-Submitted", value: 9 },
        { label: "Partially Rejected by Dealer", value: 11 },
        { label: "Rejected by Dealer", value: 12 },
        { label: "Received with Damaged Items Accepted", value: 13 },
        { label: "Received", value: 15 },
      ],
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-2",
    },
  ];

  const isSubmit = !(
    filterFormData?.is_order_accepted === 2 ||
    filterFormData?.is_order_accepted === 3
  );

  // const isExport = filterFormData?.is_order_accepted === 1;
  // const isHold = filterFormData?.is_order_accepted === 4;
  // const isOrderPartiallyApproved = filterFormData?.is_order_accepted === 5;
  // const isOrderPending = filterFormData?.is_order_accepted === 0;
  // const isOrderApproved = filterFormData?.is_order_accepted === 1;
  // const isModified = filterFormData?.is_order_accepted === 8;
  // const reSubmitted = filterFormData?.is_order_accepted === 9;

  const isExport = filters?.is_order_accepted === 1;
  const isHold = filters?.is_order_accepted === 4;
  const isOrderPartiallyApproved = filters?.is_order_accepted === 5;
  const isOrderPending = filters?.is_order_accepted === 0;
  const isOrderApproved = filters?.is_order_accepted === 1;
  const isModified = filters?.is_order_accepted === 8;
  const reSubmitted = filters?.is_order_accepted === 9;

  const handleMailFunc = async (row) => {
    var text = row?.po_id;
    var encoded = base64.encode(text);
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/attchement-send-emailto-dealer/${encoded}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Mail sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    }
  };

  const DownLoadPdf = (row) => {
    var text = row?.po_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}purchaseorder/challan/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };

  const handleOrderClaimIcon = (row) => {
    console.log("Claim Icon Clicked", row);
    handleViewDetails(row);
  };

  const handleViewDetails = async (item) => {
    // setShowSerialModal(true);
    handleModalOpen();
    setSelectedPoId(item.po_id ?? null);
    // Handle viewing details of the item here
    console.log("View details for item:", item);
    try {
      // setLoading(true)
      const response = await axiosInstance.get(
        `/acceptByOEM/sampleMissingDamagePodetails/${item.po_id}`,
        // {
        //   orderBy: "postockinsr_id desc",
        //   page: 0,
        //   pageSize: 10,
        //   endDate: null,
        //   startDate: null,
        //   po_details_id: item.po_details_id,
        //   searchText: null,
        // },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.map((item, index) => ({
        ...item,
        // "Sr No.": index + 1,
        // chassis_no: item.chassis_no || "--",
        // vin_no: item.vin_no || "--",
        // chassis_no: item.chassis_no || "--",
        remark: item.dealer_approval_remark || "",
        remark_admin: "",
        dealer_ack_remark: "",
      }));
      console.log(formattedData, "formattedDAta");
      setActionTakenAdmin(formattedData);

      const fetchedData = response?.data?.data?.data[0]?.itemtype;
      // setItemTypeData(fetchedData);
      console.log(fetchedData, "fetchedDataHandleView");

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      setTotalRecords(totalRecordsData);

      console.log(response, "serialdata");
      // setTotalPages(Math.ceil(response?.data?.data?.totalRecords / page));
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    } finally {
      // setLoading(false)
    }
  };

  console.log(actionTakenAdmin, "actionTakenadmin");

  const handleSerialTableReject = async (actionTakenAdmin) => {
    // Build the payload array from actionTaken
    const approvalData = actionTakenAdmin.map((row) => ({
      vin_no: row.vin_no || null,
      serial_no: row.serial_no || null,
      remark: row.remark || "",
      approvalStatus: 0,
    }));

    Swal.fire({
      title: "Are you sure?",
      text: "You want to submit the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.patch(
            `/acceptByOEM/acceptMissingDamagePodeetails/${selectedPoId}`,
            { approvalData },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            await showAlert({
              title: "Success",
              text: "Submitted successfully.",
              icon: "success",
              confirmButtonText: "OK",
            });
            // close modal on success
            setShowSerialModal(false);
            // optional: refresh list
            fetchActionTaken();
          }
        } catch (error) {
          console.error("Error adding dealer:", error);
          console.error("Error submitting form:", error);

          // Error alert
          const errorMessage = error.response?.data?.message;
          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              console.log("Error alert confirmed");
            },
          });
        }
      }
    });
  };

  const handleSerialTableSubmit = async (actionTakenAdmin) => {

    const hasEmptyRemark = actionTakenAdmin.some(
    (row) => !row.remark_admin || row.remark_admin.trim() === ""
  );

  if (hasEmptyRemark) {
    showErrorAlert({
      title: "Validation Error",
      text: "Admin remark should be added for all rows.",
    });
    return; 
  }

    // Build the payload array from actionTaken
    const approvalData = actionTakenAdmin.map((row) => ({
      vin_no: row.vin_no || null,
      serial_no: row.serial_no || null,
      remark_admin: row.remark_admin || "",
      approvalStatus: 1,
    }));

    Swal.fire({
      title: "Are you sure?",
      text: "You want to submit the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.patch(
            `/acceptByOEM/acceptMissingDamagePodeetails/${selectedPoId}`,
            { approvalData },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            await showAlert({
              title: "Success",
              text: "Submitted successfully.",
              icon: "success",
              confirmButtonText: "OK",
            });
            // close modal on success
            setShowSerialModal(false);
            // optional: refresh list
            fetchActionTaken();
          }
        } catch (error) {
          console.error("Error adding dealer:", error);

          console.error("Error submitting form:", error);

          // Error alert
          const errorMessage = error.response?.data?.message;
          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              console.log("Error alert confirmed");
            },
          });
        }
      }
    });
  };

  const SERIAL_TABLE_HEADERS = ["Sr No.", "Item Name", "VIN No", "Serial No"];

  const serialKeyMapping = {
    "Sr No.": (row, idx) => idx + 1,
    "Item Name": "item_name",
    "VIN No": "vin_no",
    "Serial No": "serial_no",
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5>Order Management</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>Total Orders</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalActive || 0} </h5>
                <h6>New Orders</h6>
              </div>
              <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{totalInactive || 0} </h5>
                <h6>Approved Orders</h6>
              </div>
              <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{rejectedOrders || 0} </h5>
                <h6>Rejected Orders</h6>
              </div>
            </div>
          </div>
          <ListLogisticsFilters
            formConfig={PhysicalStockTakingInputs}
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleSearch}
            handleClear={clearFilter}
          />
          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Order List</h5>
                <div>
                  <SearchInput
                    placeholder="Search By PO No./PO Type"
                    onSearch={fetchActionTaken}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
              </div>
            </div>
            <DetailsTable
              data={actionTaken}
              headers={TABLE_HEADERS}
              keyMapping={keyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              handleViewButton={handleEditButton}
              totalRecords={totalRecords}
              isSubmit={isSubmit}
              isExport={isExport}
              fetchActionTaken={fetchActionTaken}
              isOrderPending={isOrderPending}
              isOrderApproved={isOrderApproved}
              isModified={isModified}
              reSubmitted={reSubmitted}
              isOrderPartiallyApproved={isOrderPartiallyApproved}
              isHold={isHold}
              handleMailFunc={handleMailFunc}
              pdfDownLoad={DownLoadPdf}
              handleOrderClaimIcon={handleOrderClaimIcon}
              handleSearch={handleSearch}
            />
          </div>
        </div>
      )}

      {showSerialModal && (
        <div className="custom-modal-overlay-serialNo">
          <div className="custom-modal-serialNo">
            <div className="custom-modal-header">
              <h6 style={{ fontSize: "18px" }}>Order Details</h6>
              <button
                className="close-button"
                onClick={() => setShowSerialModal(false)}
              >
                ×
              </button>
            </div>
            <div className="custom-modal-body-serialNo">
              {actionTakenAdmin && actionTakenAdmin.length > 0 ? (
                <div>
                  <div className="tableWrapper" style={{ overflowX: "auto" }}>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          {SERIAL_TABLE_HEADERS.map((header, idx) => (
                            <th key={idx}>{header}</th>
                          ))}
                          {/* <th>Status</th> */}
                          <th>Remark</th>
                          <th>Remark By Admin</th>
                          {/* <th>Acknowledged By Dealer</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {actionTakenAdmin.map((row, idx) => (
                          <tr key={idx}>
                            {SERIAL_TABLE_HEADERS.map((header, hidx) => (
                              <td key={hidx}>
                                {typeof serialKeyMapping[header] === "function"
                                  ? serialKeyMapping[header](row, idx)
                                  : (row[serialKeyMapping[header]] ?? "--")}
                              </td>
                            ))}

                            <td>
                              <input
                                type="text"
                                value={row.remark || ""}
                                disabled={!!row.dealer_approval_remark}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setActionTakenAdmin((prev) =>
                                    prev.map((r, i) =>
                                      i === idx ? { ...r, remark: value } : r,
                                    ),
                                  );
                                }}
                                className="form-control"
                                placeholder="Enter remark"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={row.remark_admin || ""}
                                // disabled={!!row.remark_admin}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setActionTakenAdmin((prev) =>
                                    prev.map((r, i) =>
                                      i === idx
                                        ? { ...r, remark_admin: value }
                                        : r,
                                    ),
                                  );
                                }}
                                className="form-control"
                                placeholder="Enter admin remark"
                              />
                            </td>
                            {/* <td>
                              <input
                                type="text"
                                value={row.dealer_ack_remark || ""}
                                // disabled={!!row.dealer_ack_remark}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setActionTakenAdmin((prev) =>
                                    prev.map((r, i) =>
                                      i === idx
                                        ? { ...r, dealer_ack_remark: value }
                                        : r,
                                    ),
                                  );
                                }}
                                className="form-control"
                                placeholder="Enter remark"
                                style={{
                                  minWidth: "220px",
                                  minHeight: "42px",
                                  fontSize: "16px",
                                }}
                              />
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "24px",
                        marginBottom: "8px",
                        gap: "1rem",
                      }}
                    >
                      {/* <button
                        className="btn btn-primary"
                        style={{
                          background: "#7BD755",
                          color: "white",
                          border: "none",
                          borderRadius: "20px",
                          padding: "10px 28px",
                          fontWeight: 600,
                          fontSize: "16px",
                          minWidth: "140px",
                        }}
                        onClick={() =>
                          handleSerialTableReject(actionTakenAdmin)
                        }
                      >
                        Reject
                      </button> */}
                      <button
                        className="btn btn-primary"
                        style={{
                          background: "#7BD755",
                          color: "white",
                          border: "none",
                          borderRadius: "20px",
                          padding: "10px 28px",
                          fontWeight: 600,
                          fontSize: "16px",
                          minWidth: "140px",
                        }}
                        onClick={() =>
                          handleSerialTableSubmit(actionTakenAdmin)
                        }
                      >
                        Accept
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-center">No serial details available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderManagementListService;
